var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,0V16.2h4v-3.3h1.8v3.3h4V0H4Zm1.1,1.1h1.8v1.8h-1.8V1.1Zm2.9,0h1.8v1.8h-1.8V1.1Zm2.9,0h1.8v1.8h-1.8V1.1Zm-5.9,2.9h1.8v1.8h-1.8v-1.8Zm2.9,0h1.8v1.8h-1.8v-1.8Zm2.9,0h1.8v1.8h-1.8v-1.8ZM0,4.8v11.4H3.7V4.8H0Zm14.3,0v11.4h3.7V4.8h-3.7ZM1.1,5.9h1.5v1.5H1.1v-1.5Zm14.3,0h1.5v1.5h-1.5v-1.5Zm-10.3,1.1h1.8v1.8h-1.8v-1.8Zm2.9,0h1.8v1.8h-1.8v-1.8Zm2.9,0h1.8v1.8h-1.8v-1.8ZM1.1,8.4h1.5v1.5H1.1v-1.5Zm14.3,0h1.5v1.5h-1.5v-1.5Zm-10.3,1.5h1.8v1.8h-1.8v-1.8Zm2.9,0h1.8v1.8h-1.8v-1.8Zm2.9,0h1.8v1.8h-1.8v-1.8ZM1.1,11h1.5v1.5H1.1v-1.5Zm14.3,0h1.5v1.5h-1.5v-1.5ZM1.1,13.6h1.5v1.5H1.1v-1.5Zm14.3,0h1.5v1.5h-1.5v-1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.98ef2bbc5f94fb59ee0429e1be262e64.svg";
export { ForwardRef as ReactComponent };